<div class="card">
  <div class="header-card separator pt-0">
    <div class="w-3 container-title">
      <h1 class="text-xl font-medium text-800 my-0">
        Importaciones Masivas de Programas
      </h1>
    </div>
    <div class="col-9 flex align-items-center justify-content-end flex-wrap gap-2">
        <p-button
          label="{{'UserPalletStock.Refresh' | translate}}"
          icon="pi pi-refresh"
          styleClass="p-button-secondary"
          class="custom-text-button"
          (click)="getImports()">
        </p-button>
      </div>
  </div>
  <div class="body-card pt-3">
    <p-table
      [value]="imports"
      [paginator]="true"
      class="custom-table"
      [rows]="pageSize"
      [totalRecords]="totalRecords"
      [loading]="loading"
      [lazy]="true"
      (onLazyLoad)="getCountriesPaged($event)"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>
            <div class="flex justify-content-center">
              Nombre del Archivo
            </div>
          </th>
          <th>
            <div class="flex justify-content-center">
              Programas
            </div>
          </th>
          <th>
            <div class="flex justify-content-center">
              Líneas
            </div>
          </th>
          <th>
            <div class="flex justify-content-center">
              Progreso
            </div>
          </th>
          <th>
            <div class="flex justify-content-center">
              Estado
            </div>
          </th>
          <th>
            <div class="flex justify-content-center">
              Mensaje
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-import>
        <tr>
          <td>
            <div class="flex justify-content-center">
              {{ import.fileName }}
            </div>
          </td>
          <td>
            <div class="flex justify-content-center">
              {{ import.programsProcessed }} / {{ import.programs }}
            </div>
          </td>
          <td>
            <div class="flex justify-content-center">
              {{ import.linesProcessed }} / {{ import.lines }}
            </div>
          </td>
          <td>
            <div class="flex justify-content-center align-items-center gap-2">
              <p-progressBar
                [value]="getProgress(import)"
                [showValue]="false"
                [style]="{'width': '100px', 'height': '10px'}"
              ></p-progressBar>
              <span class="text-sm">{{ getProgress(import) }}%</span>
            </div>
          </td>
          <td>
            <div class="flex justify-content-center">
              <span class="status-text" [ngClass]="getStatusClass(import.status)">
                {{ getStatusLabel(import.status) }}
              </span>
            </div>
          </td>
          <td>
            <div class="flex justify-content-center">
              <p-button
                icon="pi pi-eye"
                pTooltip="Ver mensaje"
                tooltipPosition="bottom"
                styleClass="p-button-primary p-button-rounded p-button-text"
                (onClick)="showMessage(import.errorMessage)"
                class="action-btn eye-icon"
                [disabled]="!import.errorMessage"
                />
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="text-center">
            No hay importaciones registradas
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog
[resizable]="false"
[modal]="true"
[draggable]="false"
[(visible)]="visibleMessage"
[style]="{width: '25vw'}"
>
  <p>{{message}}</p>
</p-dialog>
